import { AnalyticsBrowser } from '@segment/analytics-next';

import CONFIG from '../configs';

export const analytics = AnalyticsBrowser.load({
  writeKey: CONFIG.SEGMENT_WRITE_KEY as string,
});
